module.exports = __webpack_public_path__ + "titus.logo.3d66c.svg";